module.exports = __webpack_public_path__ + "static/img/12.0a8c26e1.png";